import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Table, TableSizes } from '@shared/floor-plans';
import { CanvasObjectsEnum, Shapes } from '@shared/core';
import { SIZE_TO_TEXT } from '../../constants';

export interface CanvasObjectDrag {
  shape: Shapes;
  size: TableSizes;
  objectType: CanvasObjectsEnum;
  x: number;
  y: number;
}

@Component({
  selector: 'tablesready-tables',
  templateUrl: './tables.component.html',
  styleUrls: ['./tables.component.scss'],
})
export class TablesComponent {
  @Output() elementDragged = new EventEmitter<CanvasObjectDrag>();
  @Input() sizeText = SIZE_TO_TEXT;
  @Input() disabled = false;

  sizes = TableSizes;
  tables: Table[] = [
    {
      size: TableSizes.small,
      shape: Shapes.square,
    },
    {
      size: TableSizes.medium,
      shape: Shapes.square,
    },
    {
      size: TableSizes.large,
      shape: Shapes.square,
    },
    {
      size: TableSizes.small,
      shape: Shapes.circle,
    },
    {
      size: TableSizes.medium,
      shape: Shapes.circle,
    },
    {
      size: TableSizes.large,
      shape: Shapes.circle,
    },
    {
      size: TableSizes.small,
      shape: Shapes.rectangular,
    },
    {
      size: TableSizes.medium,
      shape: Shapes.rectangular,
    },
    {
      size: TableSizes.large,
      shape: Shapes.rectangular,
    },
  ];

  dragElement(dragEvent: MouseEvent | TouchEvent, shape: Shapes, size: TableSizes): void {
    let offsetX = 0;
    let offsetY = 0;

    if (dragEvent instanceof MouseEvent) {
      offsetX = dragEvent.clientX;
      offsetY = dragEvent.clientY;
    } else if (window.TouchEvent && dragEvent instanceof TouchEvent && dragEvent.touches?.length > 0) {
      offsetX = dragEvent.touches[0].clientX;
      offsetY = dragEvent.touches[0].clientY;
    }

    this.elementDragged.emit({
      shape,
      size,
      objectType: CanvasObjectsEnum.table,
      x: offsetX,
      y: offsetY,
    });
  }
}
